import Vue from 'vue'

const comment = {
  state: {
    comments: [],
    selectedComment: {},
    saving: false,
    searchCount: 0,
  },

  getters: {
    comments(state) {
      return state.comments
    },
    selectedComment(state) {
      return state.selectedComment
    },
    loading(state) {
      return state.searchCount > 0
    },
  },

  mutations: {
    comments(state, payload) {
      state.comments = payload
    },
    selectedComment(state, payload) {
      state.selectedComment = JSON.parse(JSON.stringify(payload))
    },
    saving(state, payload) {
      state.saving = payload
    },
    searchCount(state, payload) {
      state.searchCount = payload
    },
    increaseSearchCount(state, payload) {
      state.searchCount = state.searchCount + 1
    },
    decreaseSearchCount(state, payload) {
      state.searchCount = state.searchCount - 1
    },
  },

  actions: {
    setSelectedComment(context, payload) {
      context.commit('selectedComment', payload)
    },
    loadComments(context, payload) {
      return new Promise((resolve, reject) => {
        const url = 'Comment'
        context.commit('increaseSearchCount')
        Vue.prototype.$axios.get(url).then(
          (res) => {
            context.commit('comments', res.data)
            context.commit('decreaseSearchCount')
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.commit('decreaseSearchCount')
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          }
        )
      })
    },
    refreshSelectedComment(context, payload) {
      if (context.state.selectedComment && context.state.selectedComment.ID) {
        context.dispatch(
          'loadSelectedComment',
          context.state.selectedComment.ID
        )
      }
    },
    loadSelectedComment(context, payload) {
      if (
        context.state.selectedComment &&
        context.state.selectedComment.ID != payload
      ) {
        context.commit('selectedComment', {})
      }
      return new Promise((resolve, reject) => {
        const url = 'Comment/' + payload
        Vue.prototype.$axios.get(url).then(
          (res) => {
            context.commit('selectedComment', res.data)
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          }
        )
      })
    },
    clearLookupCacheAndReloadComments(context, payload) {
      caches.delete('apilookup-cache').finally(() => {
        context.dispatch('loadComments')
      })
    },
    updateComment(context, payload) {
      return new Promise((resolve, reject) => {
        const url = `Comment/${payload.ID}`
        context.commit('saving', true)
        Vue.prototype.$axios.put(url, payload).then(
          (res) => {
            context.dispatch(
              'messages/toastMessage',
              { color: 'success', message: 'comment updated' },
              { root: true }
            )
            //if you will always need to reload the list after an update
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadComments')
            context.commit('saving', false)
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.commit('saving', false)
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          }
        )
      })
    },
    createComment(context, payload) {
      return new Promise((resolve, reject) => {
        const url = `Comment`
        context.commit('saving', true)
        Vue.prototype.$axios.post(url, payload).then(
          (res) => {
            context.dispatch(
              'messages/toastMessage',
              { color: 'success', message: 'comment created' },
              { root: true }
            )
            //if you will always need to reload the list after an item is created
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadComments')
            context.commit('saving', false)
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.commit('saving', false)
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          }
        )
      })
    },
    saveComment(context, payload) {
      return new Promise((resolve, reject) => {
        if (payload.ID > 0) {
          context.dispatch('updateComment', payload).then(
            (res) => resolve(res),
            (err) => reject(err)
          )
        } else {
          context.dispatch('createComment', payload).then(
            (res) => resolve(res),
            (err) => reject(err)
          )
        }
      })
    },
    deleteComment(context, payload) {
      return new Promise((resolve, reject) => {
        const url = `Comment/${payload.ID}`
        Vue.prototype.$axios.delete(url).then(
          (res) => {
            context.dispatch(
              'messages/toastMessage',
              { color: 'success', message: 'comment deleted' },
              { root: true }
            )
            //if you will always need to reload the list after a delete
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadComments')
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          }
        )
      })
    },
  },
}

export default comment
